export default __webpack_public_path__ + "static/media/video.01a15864.png";